module.exports = __webpack_public_path__ + "img/big-logo.3241d8d8.png";